var data = { header:{ text:"#### Warning",
    closeButton:true },
  body:{ text:"Secondary Findings Add-on must be ordered in conjunction with another Exome test (Trio, Duo, or Proband-only). Please add one of these tests to the cart before adding Secondary Findings Add-on." },
  buttons:[ { text:"OK",
      isPrimary:true } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=exome_secondary_findings_add_on_without_exome_error.esm.js.map
